export var defaultProps = {
    mask: true,
    showClose: true,
    noFooter: true,
    noOkBtn: true,
    noCancelBtn: true,
    okText: '确定',
    cancelText: '取消',
    closeOnPressEscape: true,
    maskClosable: true,
    lockScroll: true,
    onOk: function () { },
    onCancel: function () { },
    onClose: function () { },
    onCancelBtn: function () { },
    onBeforeCancel: function () { },
    onAnimationClose: function () { },
    onCancelHandler: function () { },
};
